export default __webpack_public_path__ + "static/media/ExitIntentCMLogo.5ea64c67.png";